import { Commit } from "vuex";
import { request, url } from "@/api";
import { RootState } from "@/store";

export interface Captcha {
  captchav_verify_param: any;
  scene_id: string;
}

export interface Verify {
  captcha: Captcha;
  sn_code: string;
  security_code?: string;
}

const state = {};

interface Context {
  commit: Commit;
  rootState: RootState;
}

const actions = {
  check(context: Context, verify: Verify) {
    return request({
      method: "post",
      url: url.check,
      data: verify
    });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
